import React from "react";

export interface INotImplementedProps {
  title: string;
  componentName: string;
}

export const NotImplemented: React.FC<INotImplementedProps> = ({
  title,
  componentName
}: INotImplementedProps): JSX.Element => {
  return (
    <article className="lab-frame lab-frame--todo">
      <div className="lab-todo">
        <span className="lab-todo__badge">draft</span>
        <h1 className="lab-todo__title">{title}</h1>
        <p className="lab-todo__hint">
          Showcase for <code>{componentName}</code> is queued. The component is wired but not yet documented in the lab.
        </p>
      </div>
    </article>
  );
};
